	export enum MedicalReportRecommendationEnum {
    ContUse = 1,
    Binaural = 2,
    Right = 3,
    Left = 4
	}
